// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx","729":"component---src-pages-traitorous-number-tsx"}[chunkId] + "-" + {"218":"875b6bb6e86c85a72a6b","532":"8a7bb1f5a75f8ab520d4","691":"81f3a938a931f797f9dd","729":"eff2fea9b7211e10e8ab"}[chunkId] + ".js";
};